import { BodyPartChildOptionValueEnum } from '@constant';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStoreBodyPart } from '@types';

const initialState: IStoreBodyPart = {
  [BodyPartChildOptionValueEnum.손]: false,
  [BodyPartChildOptionValueEnum.발]: false,
  [BodyPartChildOptionValueEnum.팔]: false,
  [BodyPartChildOptionValueEnum.다리]: false,
  [BodyPartChildOptionValueEnum.입]: false,
  [BodyPartChildOptionValueEnum.눈]: false
};

export const bodyPartSlice = createSlice({
  name: 'bodyPart',
  initialState,
  reducers: {
    initBodyPart: () => {
      return initialState;
    },

    setBodyPart: (state, action: PayloadAction<IStoreBodyPart>) => {
      return { ...state, ...action.payload };
    }
  }
});

export const { initBodyPart, setBodyPart } = bodyPartSlice.actions;

export default bodyPartSlice.reducer;
